module.exports = ".modal-header>.close{margin:-1rem -1rem -1rem auto}.modal-header>.close ~ .close{margin:-1rem -1rem -1rem 1rem}#unAuthModal .modal-content{min-height:80vh}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/unauthorized/unauthorized.component.sass
// module id = ./src/app/unauthorized/unauthorized.component.sass
// module chunks = main